import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { firstValueFrom, forkJoin, map, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

import { UrlsServices } from './urls';
import { returnMapObject, returnMapObjectImpulso } from '../utils/utils.fuctions';
import { Parameter } from '../models';
import { Params } from '../enums/impulso.enum';
import { FormGroup, ValidatorFn } from '@angular/forms';

export class SharedService {
    urls: { [key: string]: string } = environment.urlsApi;
    urlsServices: any;

    urlGeo = environment.URL_API_GEO;

    reactorBuscadorEvento = new Subject();
    reactorBuscadorPrivado = new Subject();
    reactorBuscadorMapaSet = new Subject();
    reactorBuscadorMapaQuit = new Subject();

    subject = new Subject<any>();
    resetDataSubject = this.subject.asObservable();
    //#region Parámetros
    public documentTypeParam: Array<Parameter>;
    public ethnicIdentityParam: Array<Parameter>;
    public genderIdentityParam: Array<Parameter>;
    public localitiesParam: Array<Parameter>;
    public upzUprParam: Array<Parameter>;
    public neighborhoodsParam: Array<Parameter>;
    public differentialPopulationGroupsParam: Array<Parameter>;
    public educationalLevelParam: Array<Parameter>;
    public fieldsParam: Array<Parameter>;
    public areasParam: Array<Parameter>;
    public subFieldsParam: Array<Parameter>;
    public subAreasParam: Array<Parameter>;
    public sexParam: Array<Parameter>;
    public sexualOrientationParam: Array<Parameter>;
    public disabilityTypeParam: Array<Parameter>;
    public ageGroupsParam: Array<Parameter>;
    public streetHabitabilityParam: Array<Parameter>;
    public crossBorderDisplacedPersonsParam: Array<Parameter>;
    public schoolShiftParam: Array<Parameter>;
    public stratumParam: Array<Parameter>;
    public promotionProgramsParam: Array<Parameter>;
    public cultureSportsRecreationSectorEntitiesParam: Array<Parameter>;
    public culturalEquipmentParam: Array<Parameter>;
    public approachesParam: Array<Parameter>;
    public attentionModalityParam: Array<Parameter>;
    public strategicLinesParam: Array<Parameter>;
    public culturedCategoryParam: Array<Parameter>;
    public culturedSubCategoriesParam: Array<Parameter>;
    public siconStatesParam: Array<Parameter>;
    public siconModalitiesParam: Array<Parameter>;
    public profilesParam: Array<Parameter>;
    public paymentMethodsParam: Array<Parameter>;
    public socialGroupsParam: Array<Parameter>;
    public socialSectorsParam: Array<Parameter>;
    public daysOfTheWeekParam: Array<Parameter>;
    public eventsTypesParam: Array<Parameter>;
    public countriesParam: Array<Parameter>;
    public publicRoleParam: Array<Parameter>;
    public educativeRoleParam: Array<Parameter>;
    public institutionalSectorParam: Array<Parameter>;
    public actuationLevelParam: Array<Parameter>;
    public instrumentsOfManagementParam: Array<Parameter>;
    public tipoApoyoParam: Array<Parameter>;
    public apoyoAccesibilidadParam: Array<Parameter>;
    public listaPoblacionesParam: Array<Parameter>;
    public nivelEducativoInstitucionParam: Array<Parameter>;
    public naturalezaInstitucionEducativaParam: Array<Parameter>;
    public tipoInstitucionEducativaParam: Array<Parameter>;
    public programasCulturalesParam: Array<Parameter>;
    public artisanTradeParam: Array<Parameter>;
    public statusHacedoresParam: Array<Parameter>;
    //#endregion

    //#region Getters utilidades de la aplicación
    get user_id(): number {
        return JSON.parse(localStorage.getItem('auth_user') || '{}').id;
    }
    get vc_uuid(): number {
        return JSON.parse(localStorage.getItem('auth_user') || '{}').vc_uuid;
    }
    get completed(): boolean {
        return JSON.parse(localStorage.getItem('auth_user') || '{}').completed;
    }
    set completed(value: boolean) {
        const user = JSON.parse(localStorage.getItem('auth_user') || '{}');
        user.completed = value;
        localStorage.setItem('auth_user', JSON.stringify(user));
    }
    get vc_names(): boolean {
        return JSON.parse(localStorage.getItem('auth_user') || '{}').vc_names;
    }
    get isAdmin(): boolean {
        return JSON.parse(localStorage.getItem('auth_user') || '{}').admin;
    }
    get email(): string {
        return JSON.parse(localStorage.getItem('auth_user') || '{}').vc_email;
    }

    get loggedIn(): boolean {
        return !!localStorage.getItem('auth_token');
    }

    get ecosistema(): string {
        const roles = localStorage.getItem('ecosistema');
        return roles ? roles : undefined!;
    }
    //#endregion
    constructor(
        public http: HttpClient,
        @Inject('serviceName') public service: string
    ) {
        this.urlsServices = UrlsServices;
    }

    //#region Métodos de autenticación
    signIn = (data: any): Observable<any> =>
        this.http.post<any>(`${this.urls['transversal']}${this.urlsServices[this.service] || ''}/login`, data).pipe(
            map((response) => {
                localStorage.setItem('auth_user', JSON.stringify(response.user));
                localStorage.setItem('auth_token', response.access_token);
                this.setEcosistema(response.user.definition);
                this.dispatchData({ singIn: true });

                return response;
            })
        );

    resetLink = (data: any): Observable<any> =>
        this.http.post<any>(`${this.urls['transversal']}/sendResetLink`, data).pipe(
            map((response) => {
                return response;
            })
        );

    resetPassword = (data: any): Observable<any> =>
        this.http.post<any>(`${this.urls['transversal']}/resetPassword`, data).pipe(
            map((response) => {
                return response;
            })
        );

    //#endregion

    //#region Métodos http
    get = (url: string, additional: string = ''): Observable<any> => this.http.get<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`);
    getOne = (id: number | string, url: string, additional: string = ''): Observable<any> => this.http.get<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}${id}`);
    getAll = (url: string, additional: string = '', params?: any): Observable<any> => this.http.get<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, { params });
    getManyUrl = (additional: string = '', url: string): Observable<any> => this.http.get<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`);
    getMany = (items: any, url: string, additional: string = ''): Observable<any> => this.http.post<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, items);

    getGeo(latitude: string, longitude: string) {
        return this.http.get<any>(`${this.urlGeo}/lat/${latitude}/long/${longitude}`, {
            headers: { bearer: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9' },
        });
    }

    addOne = (item: any, url: string, additional: string = ''): Observable<any> => this.http.post<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, item);
    addMany = (items: any, url: string, additional: string = ''): Observable<any> => this.http.post<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, items);

    patchOneUrl = (item: any, url: string, additional: string = ''): Observable<any> => this.http.patch<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, item);

    update = (item: any, url: string, additional: string = ''): Observable<any> => this.http.put<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, item);
    updateOne = (item: any, id: string | number, url: string, additional: string = ''): Observable<any> => this.http.put<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}/${id}`, item);
    updateMany = (items: any[], url: string, additional: string = ''): Observable<any> => this.http.put<any[]>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, items);

    removePost = (item: any, url: string, additional: string = ''): Observable<any> => this.http.post<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, item);
    removeOne = (id: any, url: string, additional: string = ''): Observable<any> => this.http.delete<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}/${id}`);
    removeMany = (ids: any, url: string, additional: string = ''): Observable<any> => this.http.delete<any>(`${this.urls[url]}${this.urlsServices[this.service] || ''}${additional}`, { body: ids });

    dispatchData = (data: any) => this.subject.next(data);

    getLocalData = (key: string): any => JSON.parse(localStorage.getItem(key) || '{}');
    //#endregion

    //#region Parámetros
    getParamsChildren = (param: number, params: Array<number>): Promise<void> => {
        return new Promise((resolve, reject) => {
            const requests = params.map((x) => this.http.get<any>(`${this.urls['lenguaje']}/getParametersDetailChildren/${x}/consult`).pipe(map((x) => returnMapObject(x))));
            firstValueFrom(forkJoin(requests))
                .then((data) => {
                    this.setParams(param, data.flat());
                    resolve();
                })
                .catch((err) => reject(err));
        });
    };
    getParam = (param: number): Promise<void> => {
        return new Promise((resolve, reject) => {
            const localParam = localStorage.getItem(`param-${param}`);
            if (localParam) {
                this.setParams(param, JSON.parse(localParam));
                resolve();
            } else {
                firstValueFrom(this.http.get<any>(`${this.urls['lenguaje']}/getParametersDetails/${param}/consult`).pipe(map((x) => returnMapObject(x))))
                    .then((data) => {
                        this.setParams(param, data);
                        localStorage.setItem(`param-${param}`, JSON.stringify(data));
                        resolve();
                    })
                    .catch((err) => reject(err));
            }
        });
    };
    getParamParent = (param: number): Promise<void> => {
        return new Promise((resolve, reject) => {
            firstValueFrom(this.http.get<any>(`${this.urls['lenguaje']}/getParametersDetailsNoParents/${param}/consult`).pipe(map((x) => returnMapObject(x))))
                .then((data) => {
                    this.setParams(param, data);
                    localStorage.setItem(`param-${param}`, JSON.stringify(data));
                    resolve();
                })
                .catch((err) => reject(err));
        });
    };
    getParamImpulso = (param: number, active?: boolean): Promise<void> => {
        return new Promise((resolve, reject) => {
            const storageKey = `param-${param}${active !== undefined ? `-active-${active}` : ''}`;
            const localParam = localStorage.getItem(storageKey);
            if (localParam) {
                this.setParams(param, JSON.parse(localParam));
                resolve();
            } else {
                const url = `${this.urls['transversal']}/parameters/${param}/parameterDetail`;
                firstValueFrom(
                    this.http
                        .get<any>(url, {
                            params: active !== undefined ? { active } : {},
                        })
                        .pipe(map((x) => returnMapObjectImpulso(x.data)))
                )
                    .then((data) => {
                        this.setParams(param, data);
                        localStorage.setItem(storageKey, JSON.stringify(data));
                        resolve();
                    })
                    .catch((err) => reject(err));
            }
        });
    };
    getParamPais = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            const localParam = localStorage.getItem(`param-0`);
            if (localParam) {
                this.setParams(0, JSON.parse(localParam));
                resolve();
            } else {
                firstValueFrom(this.http.get<any>(`https://repositorio-ciudadano.cultured.gov.co/api/datahub/xlsx-filter?path=SCRD/4.%20Planeaci%C3%B3n/4.Gobierno%20de%20datos/ListadoPaises.xlsx&zone=azure_bronze`))
                    .then((data) => {
                        this.setParams(0, data);
                        localStorage.setItem(`param-0`, JSON.stringify(data));
                        resolve();
                    })
                    .catch((err) => reject(err));
            }
        });
    };
    getMunicipios = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            const localParam = localStorage.getItem(`param-040`);
            if (localParam) {
                this.setParams(0, JSON.parse(localParam));
                resolve();
            } else {
                firstValueFrom(this.http.get<any>(`https://repositorio-ciudadano.cultured.gov.co/api/datahub/xlsx-filter?path=SCRD/4.%20Planeaci%C3%B3n/4.Gobierno%20de%20datos/ListadoCiudades.xlsx&zone=azure_bronze&pais_id=P040`))
                    .then((data) => {
                        localStorage.setItem(`param-040`, JSON.stringify(data));
                        resolve();
                    })
                    .catch((err) => reject(err));
            }
        });
    };
    setParams = (param: number, data: any): void => {
        switch (param) {
            case Params.DOCUMENT_TYPE:
                this.documentTypeParam = data.filter((doc: Parameter) => !['2', '5'].includes(doc.id?.toString()));
                break;
            case Params.ETHNIC_IDENTITY:
                this.ethnicIdentityParam = data;
                break;
            case Params.GENDER_IDENTITY:
                this.genderIdentityParam = data;
                break;
            case Params.LOCALITIES:
                this.localitiesParam = data;
                break;
            case Params.NEIGHBORHOODS:
                this.neighborhoodsParam = data;
                break;
            case Params.DIFFERENTIAL_POPULATION_GROUPS:
                this.differentialPopulationGroupsParam = data;
                break;
            case Params.EDUCATIONAL_LEVEL:
                this.educationalLevelParam = data;
                break;
            case Params.FIELDS:
                this.fieldsParam = data;
                break;
            case Params.AREAS:
                this.areasParam = data;
                break;
            case Params.SUB_FIELDS:
                this.subFieldsParam = data;
                break;
            case Params.SUB_AREAS:
                this.subAreasParam = data;
                break;
            case Params.SEX:
                this.sexParam = data;
                break;
            case Params.SEXUAL_ORIENTATION:
                this.sexualOrientationParam = data;
                break;
            case Params.DISABILITY_TYPE:
                this.disabilityTypeParam = data;
                break;
            case Params.AGE_GROUPS:
                this.ageGroupsParam = data;
                break;
            case Params.STREET_HABITABILITY:
                this.streetHabitabilityParam = data;
                break;
            case Params.CROSS_BORDER_DISPLACED_PERSONS:
                this.crossBorderDisplacedPersonsParam = data;
                break;
            case Params.SCHOOL_SHIFT:
                this.schoolShiftParam = data;
                break;
            case Params.STRATUM:
                this.stratumParam = data;
                break;
            case Params.PROMOTION_PROGRAMS:
                this.promotionProgramsParam = data;
                break;
            case Params.CULTURE_SPORTS_RECREATION_SECTOR_ENTITIES:
                this.cultureSportsRecreationSectorEntitiesParam = data;
                break;
            case Params.CULTURAL_EQUIPMENT:
                this.culturalEquipmentParam = data;
                break;
            case Params.APPROACHES:
                this.approachesParam = data;
                break;
            case Params.ATTENTION_MODALITY:
                this.attentionModalityParam = data;
                break;
            case Params.STRATEGIC_LINES:
                this.strategicLinesParam = data;
                break;
            case Params.CULTURED_CATEGORY:
                this.culturedCategoryParam = data;
                break;
            case Params.CULTURED_SUB_CATEGORIES:
                this.culturedSubCategoriesParam = data;
                break;
            case Params.SICON_STATES:
                this.siconStatesParam = data;
                break;
            case Params.SICON_MODALITIES:
                this.siconModalitiesParam = data;
                break;
            case Params.PROFILES:
                this.profilesParam = data;
                break;
            case Params.PAYMENT_METHODS:
                this.paymentMethodsParam = data;
                break;
            case Params.SOCIAL_GROUPS:
                this.socialGroupsParam = data;
                break;
            case Params.SOCIAL_SECTORS:
                this.socialSectorsParam = data;
                break;
            case Params.DAYS_OF_THE_WEEK:
                this.daysOfTheWeekParam = data;
                break;
            case Params.EVENTS_TYPES:
                this.eventsTypesParam = data;
                break;
            case Params.COUNTRIES:
                this.countriesParam = data;
                break;
            case Params.PUBLIC_ROLE:
                this.publicRoleParam = data;
                break;
            case Params.EDUCATIVE_ROLE:
                this.educativeRoleParam = data;
                break;
            case Params.INSTITUTIONAL_SECTOR:
                this.institutionalSectorParam = data;
                break;
            case Params.ACTUACION_LEVEL:
                this.actuationLevelParam = data;
                break;
            case Params.TIPO_APOYO:
                this.tipoApoyoParam = data;
                break;
            case Params.INSTRUMENTOS_GESTION:
                this.instrumentsOfManagementParam = data;
                break;
            case Params.APOYO_ACCESIBILIDAD:
                this.apoyoAccesibilidadParam = data;
                break;
            case Params.POBLACION_PERFIL_PUBLICO:
                this.listaPoblacionesParam = data;
                break;
            case Params.TIPO_INSTITUCION_EDUCATIVA:
                this.tipoInstitucionEducativaParam = data;
                break;
            case Params.NATURALEZA_INSTITUCION_EDUCATIVA:
                this.naturalezaInstitucionEducativaParam = data;
                break;
            case Params.NIVEL_INSTITUCION_EDUCATIVA:
                this.nivelEducativoInstitucionParam = data;
                break;
            case Params.PROGRAMAS_CULTURALES_EDUCATIVO:
                this.programasCulturalesParam = data;
                break;
            case Params.ARTISAN_TRADE:
                this.artisanTradeParam = data;
                break;
            case Params.STATUS_HACEDORES:
                this.statusHacedoresParam = data;
                break;
            default:
                break;
        }
    };
    //#endregion
    setEcosistema(ecosistema: string): void {
        localStorage.setItem('ecosistema', JSON.stringify(ecosistema.toLowerCase()));
    }
    removeEcosistema(): void {
        localStorage.removeItem('ecosistema');
    }
    getMonthName(month: number): string {
        const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return months[month - 1];
    }
    enableControl(form: FormGroup, controlName: string, defaultValue: any = undefined, validators: Array<ValidatorFn> = [], emitEvent: boolean = true): void {
        form.get(controlName)!.enable({ emitEvent });
        form.get(controlName)!.setValue(defaultValue, { emitEvent });
        form.get(controlName)!.setValidators(validators);
        form.get(controlName)!.updateValueAndValidity({ emitEvent });
    }
    disableControl(form: FormGroup, controlName: string, defaultValue: any = undefined): void {
        form.get(controlName)!.disable();
        form.get(controlName)!.setValue(defaultValue);
        form.get(controlName)!.clearValidators();
        form.get(controlName)!.updateValueAndValidity();
    }
}
